import React from "react";

import Button from "@/components/input/Button";
import PageWithHeaderLayout from "@/features/layouts/PageWithHeaderLayout";
import { useAuth } from "@/services/Authentication";
import Icon from "@/components/misc/Icon";
import { getUserFullName } from "@/services/UserService";
import UserInfoDisplay from "@/features/user/UserInfoDisplay";

import { StyledHeaderTitle, StyledPage } from "./ProfilePage.styles";
import ProfileSummarySection from "./components/ProfileSummarySection";
import ProfileTabs from "./components/ProfileTabs";

const ProfilePage: React.FC = () => {
  const { userData } = useAuth();

  return (
    <PageWithHeaderLayout
      headerProps={{
        titleProps: {
          style: { display: "flex" },
          children: (
            <StyledHeaderTitle>
              {userData ? getUserFullName(userData) : ""}
            </StyledHeaderTitle>
          ),
        },
        appendContent: (
          <>
            <Button variant="ghost">
              <Icon isSrcRelative src="share_2.svg" size="sm" />
            </Button>
            <Button variant="ghost">
              <Icon isSrcRelative src="eyes.svg" size="sm" />
            </Button>
          </>
        ),
        endContainerProps: { style: { right: "0" } },
      }}
    >
      <StyledPage>
        <UserInfoDisplay />
        <ProfileSummarySection className="mt-3" />
        <ProfileTabs className="mt-4" />
      </StyledPage>
    </PageWithHeaderLayout>
  );
};

export default ProfilePage;
